import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { api } from '@/lib/api'
import { t } from '@/lib/i18n'

// OAuthConsentPage auto-completes Hydra's consent challenge for our own
// first-party MCP client (no consent UI to show — we grant the scopes).
export function OAuthConsentPage() {
  const [params] = useSearchParams()
  const [error, setError] = useState('')

  useEffect(() => {
    const challenge = params.get('consent_challenge')
    if (!challenge) { setError(t('oauthMissingChallenge')); return }
    let cancelled = false
    api.post<{ redirect_to: string }>('/api/oauth/accept-consent', { consent_challenge: challenge })
      .then(res => { if (!cancelled && res.redirect_to) window.location.href = res.redirect_to })
      .catch(() => { if (!cancelled) setError(t('oauthFailed')) })
    return () => { cancelled = true }
  }, [params])

  return (
    <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12, color: 'var(--muted)' }}>
      {error
        ? <div style={{ color: 'var(--red)', fontSize: 14 }}>{error}</div>
        : <div style={{ fontSize: 14 }}>{t('oauthConnecting')}</div>}
    </div>
  )
}
